import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Modal, Typography } from 'antd';
import HolidayForm from '../forms/holiday/HolidayForm';
import ModalStatusMessage from '../typograhpy/ModalStatusMessage';
import { db, COLLECTION_BOOKING_DATES_REF } from '../../firebase';
import logger from '../../services/logger';
import { createNewHolidayData } from '../../utils';


const propTypes = {
    visible: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
};

const { Title } = Typography;

const generateError = (bookingCount, isHoliday = false) => {
    if (isHoliday) {
        return 'You have already booked holiday on this date.';
    }

    const p = 1 < bookingCount
        ? `There are ${bookingCount} customers who have created bookings on this date. ` +
          `Please move their bookings before attempting to add holiday.`

        : 'There is 1 customer who has created a booking on this date. ' +
          'Please move their booking before attempting to add holiday.';

    return 'Could not add holiday. ' + p;
};

const createInitialState = props => ({
    visible: props.visible,
    isLoading: false,
    error: null,
    success: false,
    submitted: false,
});

class AdminAddHolidayModal extends Component {
    state = createInitialState(this.props);

    componentDidUpdate(prevProps) {
        const { visible } = this.props;

        if (prevProps.visible !== visible) {
            this.setState({ visible: visible });
        }
    }

    submitHoliday = async (selectedDate) => {
        this.setState({ isLoading: true });

        const doc = {
            id: `HOLIDAY-${selectedDate.unix()}`,
            data: createNewHolidayData(selectedDate),
        };

        try {
            const bookingDateTimeRef = db.collection(COLLECTION_BOOKING_DATES_REF);

            const snapshot = await db.collection(COLLECTION_BOOKING_DATES_REF)
                .where('date_time', '>=', selectedDate.toDate())
                .where('date_time', '<', selectedDate.add(1, 'day').toDate())
                .get();

            if (!snapshot.empty) {
                let isHoliday = snapshot.size === 1;

                if (isHoliday) {
                    snapshot.forEach(doc => {
                        const data = doc.data();

                        isHoliday = _.get(data, 'holiday') === true;
                    });
                }

                return this.setState({
                    submitted: true,
                    success: false,
                    error: generateError(snapshot.size, isHoliday),
                });
            }

            await bookingDateTimeRef.doc(doc.id).set(doc.data);

            this.setState({ success: true, submitted: true });
        } catch (e) {
            this.handleError(e);
        }
    }

    handleError = (error = null) => {
        logger.error(error);

        this.setState({ error: true, submitted: true });
    }

    handleClose = () => {
        const initialState = createInitialState(this.props);

        this.setState({ ...initialState });

        this.props.handleClose();
    }

    renderHolidayForm = () => {
        const {
            isLoading,
            error,
            success,
            submitted,
        } = this.state;

        if (submitted) {
            let message = 'Holiday successfully created';

            if (error) {
                message = error.length ? error : 'There was an error processing this request.';
            }

            return (
                <ModalStatusMessage
                    message={message}
                    variant={ success ? 'success' : 'error' }
                    handleClose={this.handleClose}
                />
            );
        }

        return (
            <HolidayForm handleAddHoliday={this.submitHoliday} loading={isLoading} />
        );
    }

    render() {
        const { visible, submitted } = this.state;

        return (
            <Modal
                title={null}
                visible={visible}
                onCancel={this.handleClose}
                footer={null}
                destroyOnClose
            >
                {
                    !submitted &&
                    <>
                        <Title level={4}>
                            Add a holiday:
                        </Title>
                        <br />
                    </>
                }
                { this.renderHolidayForm() }
            </Modal>
        );
    }
}

AdminAddHolidayModal.propTypes = propTypes;

export default AdminAddHolidayModal;
